import { useQuery } from "@tanstack/react-query";
import { HardwareSelfServiceService } from "@/services/hardware-self-service/hardware-self-service-service";
import type { HssStatusResponse } from "@/services/hardware-self-service/hardware-self-service.types";

/** Shared so mutations can invalidate the exact key this query caches under. */
export const HSS_STATUS_QUERY_KEY = ["hss", "status"] as const;

const hardwareSelfServiceService = new HardwareSelfServiceService();

export const useHssStatus = () => {
  return useQuery<HssStatusResponse, Error>({
    queryKey: HSS_STATUS_QUERY_KEY,
    queryFn: () => hardwareSelfServiceService.getStatus(),
  });
};
